<template>
  <div class="content-wrapper">
    <section class="content-header">
      <h1>Promotions</h1>
      <ol class="breadcrumb">
        <li>
          <a @click="$router.push({ name: 'dashboard' })">
            <i class="fa fa-dashboard"></i> Dashboard
          </a>
        </li>
        <li>
          <a @click="$router.push({ name: 'promo-index' })">
            <i class="fa fa-gift"></i> Promotions
          </a>
        </li>
        <li>
          <a @click="$router.push({ name: 'promo-code-index' })">
            <i class="fa fa-ticket"></i> Code
          </a>
        </li>
      </ol>
    </section>

    <section class="content">
      <div class="box">
        <div class="box-header with-border">
          <div class="box-title">
            <h3>{{ title }}</h3>
          </div>
        </div>

        <div class="box-body" style="overflow: unset;">
          <div class="row">
            <div class="col-12 col-md-12 col-lg-10">
              <div class="form-horizontal">
                <div class="form-group">
                  <label for="promo-start-date" class="col-sm-3 control-label">
                    Start Date
                    <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <datepicker
                      v-model="form.start_date"
                      :disabled="disabledStartDate"
                      input-class="form-control"
                      name="promo-start-date"
                    ></datepicker>
                  </div>
                </div>

                <div class="form-group">
                  <label for="promo-end-date" class="col-sm-3 control-label">
                    End Date
                    <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <datepicker
                      v-model="form.end_date"
                      :disabled="disabledEndDate"
                      input-class="form-control"
                      name="promo-end-date"
                    ></datepicker>
                  </div>
                </div>

                <div class="form-group">
                  <label for="promo-start-time" class="col-sm-3 control-label">
                    Start-End Time
                    <span class="req">*</span>
                  </label>

                  <div class="col-sm-3">
                    <vue-timepicker hide-clear-button format="HH:mm:ss" v-model="form.start_time"></vue-timepicker>

                    <!-- <cleave
                      type="text"
                      class="form-control"
                      id="promo-start-time"
                      name="promo-start-time"
                      placeholder="Promo start time"
                      v-model="form.start_time"
                    :options="timeOptions" />-->
                  </div>

                  <div class="col-sm-3">
                    <vue-timepicker hide-clear-button format="HH:mm:ss" v-model="form.end_time"></vue-timepicker>

                    <!-- <cleave
                      type="text"
                      class="form-control"
                      id="promo-end-time"
                      name="promo-end-time"
                      placeholder="Promo end time"
                      v-model="form.end_time"
                    :options="timeOptions" />-->
                  </div>
                </div>

                <div class="form-group">
                  <label for="promo-code" class="col-sm-3 control-label">
                    Promo Name
                    <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <input
                      required
                      style="text-transform: uppercase"
                      v-model="form.code"
                      type="text"
                      maxlength="15"
                      id="promo-code"
                      name="promo-code"
                      class="form-control"
                      pattern=".{0}|.{7,15}"
                      placeholder="Promo Code (7 to 15 chars)"
                    />
                  </div>
                </div>

                <div class="form-group">
                  <label for="promo-name" class="col-sm-3 control-label">Product Name</label>

                  <div class="col-sm-9">
                    <v-select
                      multiple
                      name="product"
                      placeholder="Select Product"
                      v-model="form.product_id"
                      :options="list.products"
                    ></v-select>
                  </div>
                </div>

                <!-- <div class="form-group">
                  <label for="promo-name" class="col-sm-3 control-label">Category</label>

                  <div class="col-sm-9">
                    <v-select
                      multiple
                      name="category"
                      placeholder="Select Product Category"
                      v-model="form.category_id"
                      :options="list.categories"
                    ></v-select>
                  </div>
                </div> -->

                <div class="form-group">
                  <label for="promo-name" class="col-sm-3 control-label">Badges</label>

                  <div class="col-sm-9">
                    <v-select
                      multiple
                      name="badges"
                      placeholder="Select Product Badges"
                      v-model="form.badges_id"
                      :options="list.badges"
                    ></v-select>
                  </div>
                </div>

                <div class="form-group">
                  <label for="promo-name" class="col-sm-3 control-label">Destination</label>

                  <div class="col-sm-9">
                    <treeselect
                      placeholder="Select Product Destination"
                      v-model="form.destination_id"
                      sort-value-by="LEVEL"
                      :value-consists-of="'ALL_WITH_INDETERMINATE'"
                      id="form"
                      ref="destinationOption"
                      :multiple="true"
                      :options="list.destinations"
                      :default-expand-level="2"
                      :auto-load-root-options="true"
                    ></treeselect>
                  </div>
                </div>

                <div class="form-group">
                  <label for="promo-name" class="col-sm-3 control-label">
                    Promo Payments
                    <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <v-select id="promo-name" v-model="form.config" :options="promoconfigs"></v-select>
                  </div>
                </div>

                <div class="form-group">
                  <label for="promo-type" class="col-sm-3 control-label">
                    Type
                    <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <v-select
                      id="promo-type"
                      v-model="form.type"
                      :on-change="switchType"
                      :options="nominalTypes"
                    ></v-select>
                  </div>
                </div>

                <div class="form-group" :class="{ 'has-error': errors.has('promo-nominal') }">
                  <label for="promo-nominal" class="col-sm-3 control-label">
                    Nominal
                    <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <div class="input-group">
                      <span class="input-group-addon" id="nominal">{{ nominalPrefix }}</span>
                      <cleave
                        v-validate="nominalValidation"
                        v-model="form.nominal"
                        @keydown="isNumber"
                        :options="{ numeral: true }"
                        :maxlength="nominalMaxLength"
                        type="text"
                        min="0"
                        id="promo-nominal"
                        name="promo-nominal"
                        class="form-control"
                        aria-describedby="nominal"
                        placeholder="Amount/Percentage"
                      />
                    </div>
                  </div>
                </div>

                <div class="form-group" v-if="showMinPayment">
                  <label for="promo-min-pay-amount" class="col-sm-3 control-label">
                    Min. Pay Amount
                    <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <input
                      v-model="form.minimum_pay_amount"
                      @keydown="isNumber"
                      type="number"
                      min="0"
                      id="promo-min-pay-amount"
                      name="promo-min-pay-amount"
                      class="form-control"
                      placeholder="Minimum payment amount"
                    />
                  </div>
                </div>

                <div class="form-group">
                  <label for="promo-max-pay-amount" class="col-sm-3 control-label">
                    Max. Promo Disc.
                    <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <input
                      v-model="form.maximum_amount"
                      @keydown="isNumber"
                      type="number"
                      min="0"
                      id="promo-max-pay-amount"
                      name="promo-max-pay-amount"
                      class="form-control"
                      placeholder="Maximum payment amount"
                    />
                  </div>
                </div>

                <div class="form-group">
                  <label for="promo-quota" class="col-sm-3 control-label">
                    Quota
                    <span class="req">*</span>
                  </label>

                  <div class="col-sm-3">
                    <input
                      v-model="form.quota"
                      @keydown="isNumber"
                      type="number"
                      min="1"
                      id="promo-quota"
                      name="promo-quota"
                      class="form-control"
                      placeholder="Quota (0 = Unlimited)"
                      :disabled="form.isUnlimitedQuota"
                    />
                  </div>

                  <div class="col-sm-3">
                    <input
                      type="checkbox"
                      v-model="form.isUnlimitedQuota"
                      @change="onUnlimitedChecked('quota')"
                    /> Unlimited Quota
                  </div>
                </div>

                <div class="form-group">
                  <label for="promo-quota" class="col-sm-3 control-label">
                    Daily Quota
                    <span class="req">*</span>
                  </label>

                  <div class="col-sm-3">
                    <input
                      v-model="form.daily_quota"
                      @keydown="isNumber"
                      type="number"
                      min="1"
                      id="promo-quota"
                      name="promo-quota"
                      class="form-control"
                      placeholder="Daily Quota (0 = Unlimited)"
                      :disabled="form.isUnlimitedDailyQuota"
                    />
                  </div>

                  <div class="col-sm-3">
                    <input
                      type="checkbox"
                      v-model="form.isUnlimitedDailyQuota"
                      @change="onUnlimitedChecked('daily_quota')"
                    /> Unlimited Daily Quota
                  </div>
                </div>

                <div class="form-group">
                  <label for="promo-min-payment" class="col-sm-3 control-label">
                    Min. Payment
                    <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <input
                      v-model="form.minimum_payment"
                      @keydown="isNumber"
                      type="number"
                      min="0"
                      id="promo-min-payment"
                      name="promo-min-payment"
                      class="form-control"
                      placeholder="Minimum payment"
                    />
                  </div>
                </div>

                <div class="form-group">
                  <label for="promo-media" class="col-sm-3 control-label">
                    Applicable To
                    <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <label class="checkbox-inline" v-for="item in medias" :for="item.value">
                      <input
                        type="checkbox"
                        :id="item.value"
                        :value="item.value"
                        v-model="form.media"
                      />
                      {{ item.label }}
                    </label>
                  </div>
                </div>

                <div class="form-group">
                  <label for="promo-available" class="col-sm-3 control-label">
                    Available To
                    <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <label class="checkbox-inline" v-for="item in availables" :for="item.value">
                      <input
                        type="checkbox"
                        :id="'available_to_' + item.value"
                        :value="item.value"
                        v-model="form.available_to"
                        @click="availableToChecked(item.value)"
                        :disabled="item.disabled"
                      />
                      {{ item.label }}
                    </label>
                  </div>
                </div>

                <!-- <div class="form-group">
                  <label for="promo-no-installment"
                    class="col-sm-3 control-label">
                    Hide Installment
                  </label>

                  <div class="col-sm-9">
                    <label class="checkbox-inline"
                      for="hide-installment">
                      <input type="checkbox"
                        id="hide-installment"
                        value="item.value"
                        v-model="form.hide_installment">
                        Hide installment
                    </label>
                  </div>
                </div>-->

                <div class="form-group">
                  <label for="restriction" class="col-sm-3 control-label">Restriction</label>

                  <div class="col-sm-9">
                    <v-select v-model="form.restriction" :multiple="true" :options="restrictions"></v-select>
                  </div>
                </div>

                <div class="form-group">
                  <label for="recurring-type" class="col-sm-3 control-label">Recurring Type</label>

                  <div class="col-sm-9">
                    <v-select
                      v-model="form.recurring_type"
                      :options="['none', 'day', 'date']"
                      style="text-transform: capitalize;"
                    ></v-select>
                  </div>
                </div>

                <div
                  class="form-group"
                  v-if="form.recurring_type !== 'none' && form.recurring_type === 'date'"
                >
                  <label for="recurring-value" class="col-sm-3 control-label">Recurring Value (Date)</label>

                  <div class="col-sm-9">
                    <v-select v-model="form.recurring_date" :multiple="true" :options="dates"></v-select>
                  </div>
                </div>

                <div
                  class="form-group"
                  v-if="form.recurring_type !== 'none' && form.recurring_type === 'day'"
                >
                  <label for="promo-media" class="col-sm-3 control-label">Recurring Value (Day)</label>

                  <div class="col-sm-9">
                    <span class="btn btn-default btn-xs" @click="toggleAllDays">All Days</span>
                    <label class="checkbox-inline" v-for="day in days" :for="day.value">
                      <input
                        type="checkbox"
                        :id="day.value"
                        :value="day.value"
                        v-model="form.recurring_day"
                      />
                      {{ day.label }}
                    </label>
                  </div>
                </div>

                <div class="form-group">
                  <label for="is-locked-domain" class="col-sm-3 control-label">Is Locked Domain</label>

                  <div class="col-sm-9">
                    <label class="radio-inline">
                      <input
                        type="radio"
                        :value="1"
                        :name="form.is_locked_domain"
                        v-model="form.is_locked_domain"
                      />
                      Yes
                    </label>
                    <label class="radio-inline">
                      <input
                        type="radio"
                        :value="0"
                        :name="form.is_locked_domain"
                        v-model="form.is_locked_domain"
                      />
                      No
                    </label>
                  </div>
                </div>

                <div class="form-group">
                  <label for="locked-domains" class="col-sm-3 control-label">Locked Domains</label>

                  <div class="col-sm-9">
                    <input
                      v-model="form.locked_domains"
                      @keydown="isStringCommaOnly"
                      :multiple="true"
                      class="form-control"
                      placeholder="Separated by comma (,)"
                    />
                  </div>
                </div>

                <div class="form-group">
                  <label for="promo-description" class="col-sm-3 control-label">
                    Description
                    <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <textarea
                      v-model="form.description"
                      type="text"
                      id="promo-description"
                      name="promo-description"
                      class="form-control"
                      placeholder="Promo description"
                    ></textarea>
                  </div>
                </div>

                <div class="form-group">
                  <label for="name" class="col-sm-3 control-label">
                    Status
                    <span class="req">*</span>
                  </label>

                  <div class="col-sm-9">
                    <v-select v-model="form.is_enabled" :options="statuses"></v-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="box-footer">
          <button class="btn btn-info pull-right" @click="submit">
            <template v-if="isCreate">Create</template>
            <template v-else>Update</template>
          </button>

          <a class="btn btn-default" @click.prevent="cancel">Cancel</a>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import moment from 'moment';
import Common from '@/mixins/Common';
import Datepicker from 'vuejs-datepicker';
import VueTimepicker from 'vue2-timepicker';
import flatten from 'lodash/flatten';
import { Treeselect, LOAD_ROOT_OPTIONS } from '@riophae/vue-treeselect';

export default {
  name: 'PromoCodeForm',

  mixins: [Common],

  data() {
    return {
      title: 'Create Promo Code',

      error: null,

      form: {
        created: null,
        promo_detail_id: null,
        promo_config_id: null,
        code: null,
        start_date: null,
        end_date: null,
        start_time: {
          HH: '00',
          mm: '00',
          ss: '00',
        },
        end_time: {
          HH: '23',
          mm: '59',
          ss: '59',
        },
        config: null,
        type: null,
        nominal: null,
        maximum_amount: null,
        minimum_pay_amount: null,
        minimum_payment: null,
        quota: null,
        daily_quota: null,
        media: [],
        restriction: 0,
        recurring_type: 'none',
        recurring_date: null,
        recurring_day: [],
        is_enabled: {
          label: 'Active',
          value: 1,
        },
        created_by: null,
        hide_installment: false,
        description: null,
        isUnlimitedQuota: false,
        isUnlimitedDailyQuota: false,
        available_to: [],
        product_id: null,
        category_id: null,
        badges_id: null,
        destination_id: null,
      },

      list: {
        products: [],
        destinations: [],
        flatDestinations: [],
        categories: [],
        badges: [],
      },

      showMinPayment: true,
      nominalMaxLength: 99,
      nominalPrefix: 'IDR',
      nominalValidation: 'required',

      promoconfigs: [],

      nominalTypes: [
        {
          label: 'Percentage',
          value: 'percentage',
        },
        {
          label: 'Amount',
          value: 'amount',
        },
      ],

      statuses: [
        {
          label: 'Active',
          value: 1,
        },
        {
          label: 'Inactive',
          value: 0,
        },
      ],

      medias: [
        {
          label: 'Web',
          value: 'web',
        },
        {
          label: 'iOS',
          value: 'ios',
        },
        {
          label: 'Android',
          value: 'android',
        },
      ],

      days: [
        {
          label: 'Mon',
          value: 1,
        },
        {
          label: 'Tue',
          value: 2,
        },
        {
          label: 'Wed',
          value: 3,
        },
        {
          label: 'Thu',
          value: 4,
        },
        {
          label: 'Fri',
          value: 5,
        },
        {
          label: 'Sat',
          value: 6,
        },
        {
          label: 'Sun',
          value: 7,
        },
      ],

      dates: [],

      restrictions: [
        {
          label: 'Email',
          value: 'email',
        },
        {
          label: 'Phone',
          value: 'phone_number',
        },
        {
          label: 'One Credit Card Usage',
          value: 'credit_card',
        },
      ],

      timeOptions: {
        numericOnly: true,
        numeralPositiveOnly: true,
        blocks: [2, 2, 2],
        delimiters: [':', ':'],
        delimiterLazyShow: true,
      },

      params: {
        page: 1,
        perpage: 500,
      },

      availables: [
        {
          label: 'All',
          value: 'all',
          disabled: false,
        },
        {
          label: 'Member',
          value: 'member',
          disabled: false,
        },
      ],
    };
  },

  props: {
    isCreate: {
      type: Boolean,
      required: false,
    },
  },

  components: {
    Datepicker,
    VueTimepicker,
    Treeselect,
  },

  computed: {
    disabledStartDate() {
      return {
        to: this.form.created
          ? moment(this.form.created).toDate()
          : moment()
              .subtract(1, 'days')
              .toDate(),
        from: this.form.end_date ? moment(this.form.end_date).toDate() : null,
      };
    },

    disabledEndDate() {
      return {
        to: this.form.start_date
          ? moment(this.form.start_date).toDate()
          : moment().toDate(),
      };
    },

    fullStartTime() {
      return `${this.form.start_time.HH}:${this.form.start_time.mm}:${this.form.start_time.ss}`;
    },

    fullEndTime() {
      return `${this.form.end_time.HH}:${this.form.end_time.mm}:${this.form.end_time.ss}`;
    },
  },

  methods: {
    setUserId() {
      this.form.created_by = this.user.sub;
    },

    getAvailablePromoConfigs() {
      return new Promise((resolve) => {
        this.axios
          .get('/promoconfigs', { params: this.params })
          .then((response) => {
            const { data } = response.data;

            if (!data) {
              resolve();
              return;
            }

            data.forEach((item) => {
              this.promoconfigs.push({
                label: item.name,
                value: item.id,
              });
            });

            resolve();
          })
          .catch((error) => {
            console.log(error);
            this.$swal({
              title: 'Failed',
              text: 'Failed to fetch available promo configs',
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#666',
              cancelButtonColor: '#3085d6',
              confirmButtonText: 'Try again',
            }).then((result) => {
              if (result.value) {
                this.getAvailablePromoConfigs();
              }
            });
          });
      });
    },

    setDates() {
      return new Promise((resolve) => {
        for (let index = 1; index <= 31; index += 1) {
          this.dates.push(index.toString());
        }

        resolve();
      });
    },

    parseDate(date, to) {
      if (!date) return '';
      const formatTo = to || 'YYYY-MM-DD';
      return moment(date).format(formatTo);
    },

    isNumber(event) {
      const charCode = event.which ? event.which : event.keyCode;

      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        event.preventDefault();
      }

      return true;
    },

    isStringCommaOnly(event) {
      const charCode = event.which ? event.which : event.keyCode;

      if (charCode > 31 && (charCode < 65 || charCode > 90)) {
        if (charCode !== 188 && charCode !== 190) {
          event.preventDefault();
        }
      }

      return true;
    },

    switchType(type) {
      if (!type) {
        this.form.type = null;
        this.showMinPayment = true;
        this.nominalMaxLength = 99;
        this.nominalPrefix = 'IDR';
        return;
      }

      if (type.value === 'percentage') {
        this.form.minimum_pay_amount = 0;
        this.showMinPayment = false;
        this.nominalMaxLength = 3;
        this.nominalPrefix = '%';
        this.nominalValidation = 'required|max_value:100';
      } else {
        this.showMinPayment = true;
        this.nominalMaxLength = 99;
        this.nominalPrefix = 'IDR';
        this.nominalValidation = 'required|numeric';
      }

      this.form.type = type;
    },

    onUnlimitedChecked(type) {
      if (type === 'quota') {
        if (this.form.isUnlimitedQuota) {
          this.form.quota = 0;
        } else {
          this.form.quota = null;
        }
      }

      if (type === 'daily_quota') {
        if (this.form.isUnlimitedDailyQuota) {
          this.form.daily_quota = 0;
        } else {
          this.form.daily_quota = null;
        }
      }
    },

    fetch() {
      this.axios
        .get(`/promo-code/${this.$route.params.id}`)
        .then((response) => {
          const { data } = response.data;

          const mediaData = [];
          const mediaAarray = data.detail.media.split(',');
          mediaAarray.forEach((selected) => {
            this.medias.forEach((item) => {
              if (item.value === selected) {
                mediaData.push(item.value);
              }
            });
          });

          let typeData = {};
          this.nominalTypes.forEach((item) => {
            if (item.value === data.detail.type) {
              typeData = item;
            }
          });

          const restrictionData = [];
          const restriction = data.detail.restriction.split(',');
          restriction.forEach((dataItem) => {
            this.restrictions.forEach((item) => {
              if (item.value === dataItem) {
                restrictionData.push(item);
              }
            });
          });

          const productsData = [];
          if (data.detail.product_id) {
            const arrayProducts = data.detail.product_id.split(',');
            arrayProducts.forEach((selected) => {
              this.list.products.forEach((item) => {
                if (item.value === parseInt(selected, 10)) {
                  productsData.push(item);
                }
              });
            });
          }

          const categoriesData = [];
          if (data.detail.category_id) {
            const arrayCategory = data.detail.category_id.split(',');
            arrayCategory.forEach((selected) => {
              this.list.categories.forEach((item) => {
                if (item.value === parseInt(selected, 10)) {
                  categoriesData.push(item);
                }
              });
            });
          }
          const arrayBadges = data.detail.badges;

          const arrayDestination = data.detail.destinations;
          // const destinationsData = [];
          // if (data.detail.destination_id) {
          //   destinationsData = data.detail.destination_id.split(',');
          //   destinationsData.forEach((selected) => {
          //     this.list.flatDestinations.forEach((item) => {
          //       if (item === parseInt(selected, 10)) {
          //         destinationsData.push(item);
          //       }
          //     });
          //   });
          // }

          let enabled = {};
          this.statuses.forEach((item) => {
            if (item.value === data.is_enable) {
              enabled = item;
            }
          });

          let promoconfigs = null;
          this.promoconfigs.forEach((item) => {
            if (item.value === data.promo_config_id) {
              promoconfigs = item;
            }
          });

          const timeStart = data.start_time || '00:00:00';
          const timeEnd = data.end_time || '23:59:59';

          const timeStartSplit = timeStart.split(':');
          const timeEndSplit = timeEnd.split(':');

          const timeStartFull = {
            HH: timeStartSplit[0] || '00',
            mm: timeStartSplit[1] || '00',
            ss: timeStartSplit[2] || '00',
          };

          const timeEndFull = {
            HH: timeEndSplit[0] || '23',
            mm: timeEndSplit[1] || '59',
            ss: timeEndSplit[2] || '59',
          };

          if (data.quota === 0) {
            this.form.isUnlimitedQuota = true;
          }

          if (data.daily_quota === 0) {
            this.form.isUnlimitedDailyQuota = true;
          }

          const recurringValue = data.detail.recurring_value.split(',');

          if (data.detail.recurring_type === 'day') {
            this.form.recurring_day = recurringValue;
          }

          if (data.detail.recurring_type === 'date') {
            this.form.recurring_date = recurringValue;
          }

          const availableData = [];
          if (data.available_to === 'all') {
            availableData.push('all', 'member');
            this.availables[1].disabled = true;
          } else {
            availableData.push('member');
          }

          this.form.code = data.code;
          this.form.created = data.created_at;
          this.form.created_by = data.created_by;
          this.form.description = data.detail.description;
          this.form.end_date = this.parseDate(data.end_date);
          this.form.end_time = timeEndFull;
          this.form.hide_installment = data.detail.hide_installment;
          this.form.is_enabled = enabled;
          this.form.maximum_amount = data.detail.maximum_amount;
          this.form.media = mediaData;
          this.form.minimum_pay_amount = data.detail.minimum_pay_amount;
          this.form.minimum_payment = data.detail.minimum_payment;
          this.form.config = promoconfigs;
          this.form.nominal = data.detail.nominal;
          this.form.promo_config_id =
            data.promo_config_id !== 0 ? data.promo_config_id : null;
          this.form.promo_detail_id = data.promo_detail_id;
          this.form.quota = data.quota;
          this.form.daily_quota = data.daily_quota;
          this.form.restriction = restrictionData;
          this.form.recurring_type = data.detail.recurring_type;
          this.form.is_locked_domain = data.detail.is_locked_domain;
          this.form.locked_domains = data.detail.locked_domains;
          this.form.start_date = this.parseDate(data.start_date);
          this.form.start_time = timeStartFull;
          this.form.type = typeData;
          this.form.product_id = productsData;
          this.form.category_id = categoriesData;
          this.form.available_to = availableData;
          if (arrayBadges) {
            const valueBadges = arrayBadges
            .map(item => ({ 
              value: item.id, 
              label: item.name, 
            }));
            this.form.badges_id = valueBadges;
          } else {
            this.form.badges_id = null;
          }
          if (arrayDestination) {
            const valueDestinations = arrayDestination
            .filter(l => !arrayDestination.find(val => l.id === val.parent_id))
            .map(l => l.id);
            this.form.destination_id = valueDestinations;
          } else {
            this.form.destination_id = null;
          }
        })
        .catch((error) => {
          if (error.response) {
            this.errors = error.response.data.errors;
          }

          if (error) {
            this.$swal({
              title: 'Failed',
              text: 'Failed to fetch promo code detail',
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#666',
              cancelButtonColor: '#3085d6',
              confirmButtonText: 'Try again',
            }).then((result) => {
              if (result.value) {
                this.fetch();
              }
            });
          }
        });
    },

    prepareValues(arr) {
      if (!arr) return [];

      // Make sure object is array
      const isItArray = Array.isArray(arr);
      if (!isItArray) {
        arr = [arr];
      }

      // Return only value
      const values = [];
      arr.forEach((item) => {
        values.push(item.value);
      });

      return values;
    },

    validate() {
      if (!this.form.start_date) {
        this.$swal(
          'Promo start date required',
          'Please fill promo start date to continue',
          'warning',
        );
        return false;
      }

      if (!this.form.end_date) {
        this.$swal(
          'Promo end date required',
          'Please fill promo end date to continue',
          'warning',
        );
        return false;
      }

      if (!this.form.start_time) {
        this.$swal(
          'Promo start time required',
          'Please fill promo start time to continue',
          'warning',
        );
        return false;
      }

      if (!this.form.end_time) {
        this.$swal(
          'Promo end time required',
          'Please fill promo end time to continue',
          'warning',
        );
        return false;
      }

      const startTime = moment(this.fullStartTime, 'HH:mm:ss');
      const endTime = moment(this.fullEndTime, 'HH:mm:ss');

      if (endTime.isBefore(startTime)) {
        this.$swal(
          'Payment time invalid',
          'Please choose correct end time to continue',
          'warning',
        );
        return false;
      }

      if (!this.form.code) {
        this.$swal(
          'Promo code required',
          'Please fill promo code to continue',
          'warning',
        );
        return false;
      }

      if (!this.form.type) {
        this.$swal(
          'Promo type required',
          'Please fill promo type to continue',
          'warning',
        );
        return false;
      }

      if (this.form.nominal === null || this.form.nominal === '') {
        this.$swal(
          'Nominal required',
          'Please fill nominal to continue',
          'warning',
        );
        return false;
      }

      if (this.form.type.value === 'percentage' && this.form.nominal > 100) {
        this.$swal(
          'Nominal Invalid',
          'Percentage nominal is greater than 100 percent',
          'warning',
        );
        return false;
      }

      if (
        this.form.type.value === 'amount' &&
        (this.form.minimum_pay_amount === '' ||
          this.form.minimum_pay_amount === null)
      ) {
        this.$swal(
          'Promo minimum pay amount required',
          'Please fill minimum pay amount to continue',
          'warning',
        );
        return false;
      }

      if (
        this.form.maximum_amount === null ||
        this.form.maximum_amount === ''
      ) {
        this.$swal(
          'Promo Maximum Discount required',
          'Please fill maximum promo discount to continue',
          'warning',
        );
        return false;
      }

      if (this.form.quota === null || this.form.quota < 0) {
        this.$swal(
          'Quota required',
          'Quota cannot be empty or less than 0',
          'warning',
        );
        return false;
      }

      if (this.form.daily_quota === null || this.form.daily_quota < 0) {
        this.$swal(
          'Quota required',
          'Daily quota cannot be empty or less than 0',
          'warning',
        );
        return false;
      }

      if (
        this.form.quota !== 0 &&
        parseInt(this.form.daily_quota, 10) > parseInt(this.form.quota, 0)
      ) {
        this.$swal(
          'Daily Quota Not Valid',
          'Daily Quota Must Be Less Than Quota',
          'warning',
        );
        return false;
      }

      if (
        this.form.minimum_payment === null ||
        this.form.minimum_payment === ''
      ) {
        this.$swal(
          'Promo minimum payment required',
          'Please fill minimum payment to continue',
          'warning',
        );
        return false;
      }

      if (!this.form.media || this.form.media.length < 1) {
        this.$swal(
          'Promo media required',
          'Please fill media to continue',
          'warning',
        );
        return false;
      }

      if (!this.form.description) {
        this.$swal(
          'Promo description required',
          'Please fill description to continue',
          'warning',
        );
        return false;
      }

      if (!this.form.is_enabled) {
        this.$swal(
          'Promo code status required',
          'Please fill promo code status to continue',
          'warning',
        );
        return false;
      }

      if (!this.form.available_to || this.form.available_to.length < 1) {
        this.$swal(
          'Promo available to required',
          'Please fill available to, to continue',
          'warning',
        );
        return false;
      }

      if (
        this.form.is_locked_domain > 0 &&
        this.form.locked_domains.length < 1
      ) {
        this.$swal(
          'Lock domain address required',
          'Please fill domain address to continue',
          'warning',
        );

        return false;
      }

      return true;
    },

    submit() {
      const result = this.validate();
      if (!result) return;

      if (this.isCreate) {
        this.create();
      } else {
        this.update();
      }
    },

    create() {
      if (this.form.nominal > 100 && this.form.type.value === 'percentage') {
        return this.$swal(
          'Nominal Invalid',
          'Percentage nominal is greater than 100 percent',
          'warning',
        );
      }

      const typeData = this.prepareValues(this.form.type);
      const restrictionData = this.prepareValues(this.form.restriction);
      const productsData =
        this.form.product_id != null
          ? this.form.product_id.map(item => item.value)
          : null;
      const categoriesData =
        this.form.category_id != null
          ? this.form.category_id.map(item => item.value)
          : null;
      const badgesData =
        this.form.badges_id != null
          ? this.form.badges_id.map(item => item.value)
          : null;
      const destinationsData =
        this.form.destination_id != null
          ? this.form.destination_id.map(item => +item)
          : null;

      let recurringValue = null;
      if (this.form.recurring_type === 'date') {
        recurringValue = this.form.recurring_date.join();
      }
      if (this.form.recurring_type === 'day') {
        recurringValue = this.form.recurring_day.join();
      }

      const data = {
        code: this.form.code,
        created_by: this.form.created_by,
        description: this.form.description,
        end_date: moment(this.form.end_date).format(this.config.date.iso),
        end_time: this.fullEndTime,
        hide_installment: this.form.hide_installment,
        is_enabled: this.form.is_enabled.value,
        maximum_amount: this.form.maximum_amount,
        media: this.form.media.toString(),
        minimum_pay_amount: this.form.minimum_pay_amount,
        minimum_payment: this.form.minimum_payment,
        nominal: this.form.nominal,
        promo_config_id: this.form.config ? this.form.config.value : null,
        promo_detail_id: this.form.promo_detail_id,
        quota: this.form.quota,
        daily_quota: this.form.daily_quota,
        restriction: restrictionData.join(),
        recurring_type: this.form.recurring_type,
        recurring_value: recurringValue,
        is_locked_domain: this.form.is_locked_domain,
        locked_domains: this.form.locked_domains,
        start_date: moment(this.form.start_date).format(this.config.date.iso),
        start_time: this.fullStartTime,
        type: typeData.toString(),
        product_id: productsData != null ? productsData.join() : productsData,
        category_id:
          categoriesData != null ? categoriesData.join() : categoriesData,
        badge_id:
          badgesData != null ? JSON.stringify(badgesData) : badgesData,
        destination_id:
          destinationsData != null ? JSON.stringify(destinationsData) : destinationsData,
        available_to: this.form.available_to.includes('all') ? 'all' : 'member',
      };

      return this.axios
        .post('/promo-code', this.stringify(data))
        .then(() => {
          this.$swal({
            title: 'Created',
            text: `${this.form.code} has been created.`,
            type: 'success',
            timer: 3000,
          });

          this.$router.push({ name: 'promo-code-index' });
        })
        .catch((error) => {
          console.log('error', error);

          if (error.response) {
            this.error = error.response.data.errors;
          }

          if (error) {
            let message = 'Failed to create new Promo Code';

            if (this.error) {
              message = this.error;
            }

            this.$swal({
              title: 'Create Failed!',
              text: message,
              type: 'warning',
              timer: 5000,
              onClose: () => {
                this.error = null;
              },
            });
          }
        });
    },

    update() {
      const typeData = this.prepareValues(this.form.type);
      const productsData =
        this.form.product_id != null
          ? this.form.product_id.map(item => item.value)
          : null;
      const categoriesData =
        this.form.category_id != null
          ? this.form.category_id.map(item => item.value)
          : null;
      const badgesData =
        this.form.badges_id != null
          ? this.form.badges_id.map(item => item.value)
          : null;
      const destinationsData =
        this.form.destination_id != null
          ? this.form.destination_id.map(item => +item)
          : null;

      let restrictionData = null;
      if (this.form.restriction.length > 0) {
        restrictionData = this.prepareValues(this.form.restriction);
        restrictionData = restrictionData.join();
      }

      let recurringValue = null;
      if (this.form.recurring_type === 'date') {
        recurringValue = this.form.recurring_date.join();
      }
      if (this.form.recurring_type === 'day') {
        recurringValue = this.form.recurring_day.join();
      }
      const data = {
        code: this.form.code,
        created_by: this.form.created_by,
        description: this.form.description,
        end_date: moment(this.form.end_date).format(this.config.date.iso),
        end_time: this.fullEndTime,
        hide_installment: this.form.hide_installment,
        is_enabled: this.form.is_enabled.value,
        maximum_amount: this.form.maximum_amount,
        media: this.form.media.toString(),
        minimum_pay_amount: this.form.minimum_pay_amount,
        minimum_payment: this.form.minimum_payment,
        nominal: this.form.nominal,
        promo_config_id: this.form.config ? this.form.config.value : null,
        promo_detail_id: this.form.promo_detail_id,
        quota: this.form.quota,
        daily_quota: this.form.daily_quota,
        restriction: restrictionData,
        recurring_type: this.form.recurring_type,
        recurring_value: recurringValue,
        is_locked_domain: this.form.is_locked_domain,
        locked_domains: this.form.locked_domains,
        start_date: moment(this.form.start_date).format(this.config.date.iso),
        start_time: this.fullStartTime,
        type: typeData.toString(),
        product_id: productsData != null ? productsData.join() : productsData,
        category_id:
          categoriesData != null ? categoriesData.join() : categoriesData,
        badge_id:
          badgesData != null ? JSON.stringify(badgesData) : badgesData,
        destination_id:
          destinationsData != null ? JSON.stringify(destinationsData) : destinationsData,
        available_to: this.form.available_to.includes('all') ? 'all' : 'member',
      };

      return this.axios
        .put(`/promo-code/${this.$route.params.id}`, this.stringify(data))
        .then(() => {
          this.$swal({
            title: 'Updated',
            text: `${this.form.code} has been updated.`,
            type: 'success',
            timer: 3000,
          });

          this.$router.push({ name: 'promo-code-index' });
        })
        .catch((error) => {
          console.log('error', error);

          if (error.response) {
            this.error = error.response.data.errors;
          }

          if (error) {
            this.$swal({
              title: 'Failed',
              text: `Failed to update ${this.form.code.label}.`,
              type: 'warning',
              timer: 5000,
            });
          }
        });
    },

    toggleAllDays() {
      if (this.form.recurring_day.length < 1) {
        this.form.recurring_day = [1, 2, 3, 4, 5, 6, 7];
      } else {
        this.form.recurring_day = [];
      }
    },

    async init() {
      await this.getAvailablePromoConfigs();
      await this.setDates();
      await this.fetchBadges();
      await this.fetchItem('products');
      await this.fetchItem('categories');
      await this.getAvailableDestination();

      if (!this.isCreate) {
        await this.fetch();
      } else {
        this.setUserId();
      }
    },

    cancel() {
      this.$router.go(-1);
    },

    fetchItem(type) {
      return new Promise((resolve) => {
        let endpoint = type;
        if (type === 'products') {
          endpoint = 'products-only';
        }
        this.axios
          .get(`/${endpoint}`, { params: this.params })
          .then((response) => {
            const { data } = response.data;
            const results = data.map(item => ({
              label: item.name,
              value: item.id,
            }));
            this.list[type] = results;
            resolve(data);
          })
          .catch((error) => {
            console.log(`Fetch ${type} error`, error);

            if (error.response) {
              this.error = error.response.data.errors;
            }

            if (error) {
              this.$swal({
                title: 'Failed',
                text: `Failed to fetch available ${type}`,
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#666',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Try again',
              }).then((result) => {
                if (result.value) {
                  this.fetchItem(type);
                }
              });
            }
          });
      });
    },
    fetchBadges() {
      return new Promise((resolve) => {
        const endpoint = 'badges/type/top';
        this.axios
          .get(`/${endpoint}`)
          .then((response) => {
            const { data } = response.data;
            if (data) {
              const results = data.map(item => ({
                label: item.name,
                value: item.id,
              }));
              this.list.badges = results;              
            }

            resolve(data);
          })
          .catch((error) => {
            console.log('Fetch badges error', error);

            if (error.response) {
              this.error = error.response.data.errors;
            }

            if (error) {
              this.$swal({
                title: 'Failed',
                text: 'Failed to fetch available badges',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#666',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Try again',
              }).then((result) => {
                if (result.value) {
                  this.fetchBadges();
                }
              });
            }
          });
      });
    },
    async getAvailableDestination() {
      const destinations = await this.fetchItem('destinations');
      this.list.destinations = await this.generate(destinations);
      this.list.flatDestinations = await this.flattenDestination(destinations);
    },

    flattenDestination(data) {
      const result = [];

      data.forEach((parent) => {
        result.push({
          id: parent.id,
          label: parent.name,
        });

        if (parent.child !== null) {
          parent.child.forEach((child) => {
            result.push({
              id: child.id,
              label: child.name,
            });

            if (child.child) {
              child.child.forEach((grandchild) => {
                result.push({
                  id: grandchild.id,
                  label: grandchild.name,
                });
              });
            }
          });
        }
      });

      return flatten(result);
    },

    generate(data) {
      if (!data) return [];

      return data.map((local) => {
        if (local.child) {
          return {
            id: local.id,
            label: local.name,
            isDefaultExpanded: true,
            children: local.child.map((parent) => {
              if (parent.child) {
                return {
                  id: parent.id,
                  label: parent.name,
                  children: parent.child.map((child) => {
                    if (child.child) {
                      return {
                        id: child.id,
                        label: child.name,
                        children: child.child.map(grandchild => ({
                          id: grandchild.id,
                          label: grandchild.name,
                        })),
                      };
                    }
                    return {
                      id: child.id,
                      label: child.name,
                    };
                  }),
                };
              }

              return {
                id: parent.id,
                label: parent.name,
              };
            }),
          };
        }

        return {
          id: local.id,
          label: local.name,
        };
      });
    },

    async loadOptions({ action }) {
      if (action === LOAD_ROOT_OPTIONS) {
        if (this.destinationListUpdated) {
          await this.getAvailableDestination();
          this.destinationListUpdated = false;
        }
      }
    },

    availableToChecked(checkboxValue) {
      if (checkboxValue === 'all') {
        if (!this.form.available_to.includes('all')) {
          if (!this.form.available_to.includes('member')) {
            this.form.available_to.push('member');
            this.availables[1].disabled = true;
          } else {
            this.availables[1].disabled = true;
          }
        } else {
          this.form.available_to.splice('member');
          this.availables[1].disabled = false;
        }
      }
    },
  },

  created() {
    this.init();

    if (!this.isCreate) {
      this.title = 'Edit Promo Code';
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/modules/promo/code/Form.vue